import {useEffect, useRef, useState} from "react";
import {Input} from "../../basic/input.tsx";
import {Search} from "lucide-react";
import {cn} from "../../../utils/utils.ts";

interface SearchInputProps {
    placeholder: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onClear?: () => void;
    className?: string;
    debounceDelay?: number;
}

export function SearchInput({
                                placeholder,
                                value,
                                onChange,
                                onClear,
                                className = "max-w-sm",
                                debounceDelay = 300
                            }: SearchInputProps) {
    const [internalValue, setInternalValue] = useState(value);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

    useEffect(() => {
        setInternalValue(value);
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setInternalValue(newValue);

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            onChange(e);
        }, debounceDelay);
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground"/>
            <Input
                placeholder={placeholder}
                value={internalValue}
                onChange={handleChange}
                className={cn("pl-10", className)}
            />
        </div>
    );
}